import { Box, Flex, Spacing, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { messages } from './SubsectionEmail.messages';

export const Loading = memo(() => {
    return (
        <Box spacing='16 0'>
            <Flex height='100%' justifyContent='space-between' alignItems='center' wrap={false}>
                <Text font='label' fontSize='large' fontWeight='regular'>
                    {messages.title}
                </Text>

                <Skeleton height={28} width={120} />
            </Flex>

            <Spacing height={8} />

            <Skeleton height={16} />

            <Skeleton height={16} />
        </Box>
    );
});

Loading.displayName = 'Loading';
